import { AnimatePresence, motion } from 'framer-motion'
import Slider from 'react-slick'
import classes from './quotesCarousel.module.scss'
import SlideComponent from './SlideComponent'
import React, { PropsWithChildren } from 'react'

export interface IQuotesCarousel {
    id: number
    picture: string
    brand: string
    description: string
}

type QuotesCarouselProps = {
    data: IQuotesCarousel[]
    interval: number
    isPlaying: boolean
    touchEnabled: boolean
    dragEnabled: boolean
}

const QuotesCarousel: React.FC<PropsWithChildren<QuotesCarouselProps>> = ({ data }) => (
  <div className={classes.fullWidthContainer}>
    <div className={classes.container}>
      <div className={classes.slider_container}>
        <div className={classes.overflowSlider}>
          <Slider
            dots
            fade
            className={classes.carouselContainer}
          >
            {data.map((item, index) => (
              <AnimatePresence exitBeforeEnter key={index}>
                <motion.div
                  initial={{ opacity: 0 }} animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <SlideComponent
                    item={item}
                  />
                </motion.div>
              </AnimatePresence>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  </div>

)

export default QuotesCarousel
